module.exports = __webpack_public_path__ + "static/favicons/favicon-128x128-8d2024e62d6ff6212d26a428ac92fc16.png";